import { NgModule } from '@angular/core';
import { AuthService } from './auth.service';
import { DoceboService } from './docebo/docebo.service';
import { OktaService } from './okta/okta.service';

@NgModule({
  providers: [AuthService, DoceboService, OktaService],
})
export class AuthModule {}
